import React, { Component } from 'react';
import {Link} from "react-router-dom";

export default class ScrollTop extends Component {
    render() {
        return (
            <>
                {/* Start Scroll to Top Area */}
                <div id="back-top">
                    <Link title="Go to Top" to="#">
                        <i className="lnr lnr-arrow-up" />
                    </Link>
                </div>
                {/* End Scroll to Top Area */}
            </>
        );
    }
}